import { render, staticRenderFns } from "./manufactureLicenseList.vue?vue&type=template&id=3b47cef9&scoped=true"
import script from "./manufactureLicenseList.vue?vue&type=script&lang=js"
export * from "./manufactureLicenseList.vue?vue&type=script&lang=js"
import style0 from "./manufactureLicenseList.vue?vue&type=style&index=0&id=3b47cef9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b47cef9",
  null
  
)

export default component.exports